module.exports = __webpack_public_path__ + "img/logo-avatar_xinxi.ea75c8f4.png";